import * as React from "react";
import { TextLink } from "@ovotech/element";

const EMAIL = "electricvehicles@ovoenergy.com";
export const EmailContact = () => (
  <TextLink href={`mailto:${EMAIL}`}>{EMAIL}</TextLink>
);
